import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import messages from './langs'
import GlobalVar from '../global'

Vue.use(VueI18n)

let languageDefault = sessionStorage.getItem('languageDefault');
// let languageDefault = GlobalVar.defaultLanguage;

const i18n = new VueI18n({
	locale: languageDefault || 'en',
	messages
});

locale.i18n((key, value) => i18n.t(key, value))

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js